import React from 'react';
import {
    ATMModal,
    ATMButton,
    ATMForm,
    ATMGrid,
    ATMInput,
    ATMField,
    ATMIcon,
    ORGDataTable,
    IORGDataTableColumn,
    IORGDataTableQueryState,
} from 'shared-it-appmod-ui';
import moment from 'moment-timezone';
import Lang from 'src/libraries/language';

type Iprops = {
    data: any;
    openAuditLogs: boolean;
    handleClose: () => void;
    loadinglog: boolean;
    fetchLogData: (params: IORGDataTableQueryState) => void;
    totalRecord: number;
};

function BlockExternalUsersAuditLogView({
    data,
    openAuditLogs,
    handleClose,
    loadinglog,
    fetchLogData,
    totalRecord,
}: Iprops): any {
    const columns: IORGDataTableColumn<any>[] = [
        {
            title: 'Spend Reporting Status',
            index: 'spendReportingStatus',
            render: (_, value) => (
                <span>{`${value?.spendReportingStatus ? 'Spend Reporting Disabled' : 'Spend Reporting Enabled'}`}</span>
            ),
            headerProps: {
                //className: Style.von,
            },
        },
        {
            title: 'Done By',
            index: 'firstName',
            sortable: false,
            render: (_, value) => (
                <span>{value?.firstName + ' ' + value?.lastName || '-'}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Timestamp',
            index: 'loggedAt',
            sortable: false,
            render: (_, value) => (
                <span>{`${value?.loggedAt != '-' ? moment.utc(value?.loggedAt).format('MM/DD/YYYY hh:mm A') : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
    ];
    return (
        <ATMModal
            size="large"
            open={openAuditLogs}
            onClose={handleClose}
            closeOnDimmerClick={false}
        >
            <ATMModal.Header as="h5">
                Enable/Disable Spend Reporting Audit Log
                <ATMIcon
                    name="close"
                    onClick={handleClose}
                    style={{
                        color: '#606060',
                        position: 'absolute',
                        right: '0',
                        top: '5px',
                        cursor: 'pointer',
                    }}
                />
            </ATMModal.Header>

            <ATMModal.Content>
                <ORGDataTable
                    celled={false}
                    columns={columns}
                    data={data}
                    loading={loadinglog}
                    sortable
                    counter
                    noDataText={Lang.MSG_NO_RECORDS_TO_DISPLAY}
                    onChange={fetchLogData}
                    total={totalRecord}
                    key={totalRecord}
                    rowsPerPageOptions={[10, 20, 25]}
                />
            </ATMModal.Content>
        </ATMModal>
    );
}

export default BlockExternalUsersAuditLogView;
